import React from "react";
import axios from "axios";
import { List } from "components/broadcast-channel/List";
import { AuthContext } from "auth";
import { formatDate } from "date";

export function ChannelList() {
  const authContext = React.useContext(AuthContext);
  const [state, dispatch] = React.useReducer(
    (s, action) => {
      switch (action.type) {
        case "FETCH_SUCCESS":
          return {
            ...s,
            channelList: action.channelList,
            isProcessing: false,
            isError: false,
          };
        case "FETCH_ERROR":
          return {
            ...s,
            isProcessing: false,
            isError: true,
          };
        case "CREATE_CLICKED":
          return {
            ...s,
            showCreationForm: true,
          };
        case "CANCEL_CREATE_CLICKED":
        case "CREATE_SUCCESS":
        case "EDIT_SUCCESS":
          return {
            ...s,
            showCreationForm: false,
          };
        default:
          return s;
      }
    },
    {
      channelList: [],
      isProcessing: true,
      isError: false,
      showCreationForm: false,
    }
  );

  const fetchList = async () => {
    try {
      const { data: channelList } = await fetchChannelList();
      dispatch({
        type: "FETCH_SUCCESS",
        channelList: channelList.map((item) => {
          return {
            ...item,
            created_at: formatDate(new Date(item.created_at)),
          };
        }),
      });
    } catch (e) {
      console.error(e);
      dispatch({
        type: "FETCH_ERROR",
      });
    }
  };

  React.useEffect(() => {
    fetchList();
  }, []);

  const onCreateSubmit = async (channel) => {
    try {
      await createChannel(authContext.user, channel);
      dispatch({ type: "CREATE_SUCCESS" });
      await fetchList();
    } catch (e) {
      console.error(e);
    }
  };

  const onEditSubmit = async (channel) => {
    try {
      await updateChannel(authContext.user, channel);
      dispatch({ type: "EDIT_SUCCESS" });
      await fetchList();
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <List
      channelList={state.channelList}
      showCreationForm={state.showCreationForm}
      onCreateClick={() => {
        dispatch({ type: "CREATE_CLICKED" });
      }}
      onCancelCreateClick={() => dispatch({ type: "CANCEL_CREATE_CLICKED" })}
      onCreateSubmit={onCreateSubmit}
      onEditSubmit={onEditSubmit}
    ></List>
  );
}

async function fetchChannelList() {
  return axios.request({
    url: `/r-api/broadcast_channel?order=id`,
    method: "GET",
  });
}

async function createChannel(user, channel) {
  return axios.request({
    url: `/program-channel-api/channel`,
    method: "POST",
    data: {
      ...channel,
      created_by: user.uid,
    },
  });
}

async function updateChannel(user, channel) {
  return axios.request({
    url: `/program-channel-api/channel/${channel.id}`,
    method: "PUT",
    data: {
      channel,
      updated_by: user.uid,
    },
  });
}
